import React from "react";
import styled from "styled-components/macro";
import { ReactComponent as SideDraw } from "../../../images/ride/TULU ride side view.svg";

const SidePlan = ({ location, standType, type }) => {
  const height = 375;

  return (
    <SideWrapper>
      <ImgWrapper>
        <SideDraw style={{ height }} />

        <DepthSpan>
          {location === "us"
            ? (25.0).toFixed(2)
            : Math.ceil(25.0 * 2.54).toFixed(2)}
        </DepthSpan>
      </ImgWrapper>
    </SideWrapper>
  );
};

export default SidePlan;

const SideWrapper = styled.div`
  position: relative;
  // width:100%;
  height: 460px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  // display:block;
`;

const ImgWrapper = styled.div`
  position: relative;
  text-align: center;
  display: inline-block;
  width: 205px;
`;

const DepthSpan = styled.div`
  position: absolute;
  left: 60.5%;
  font-family: DMSans;
  bottom: 3.5%;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.54;
  letter-spacing: normal;
  color: #6d6e6e;
`;
